export function getElementAttributes(elt: Element) {
  const attributes: any = {};
  for (let i = 0; i < elt.attributes.length; i += 1) {
    attributes[elt.attributes[i].nodeName] = elt.attributes[i].nodeValue;
  }
  return attributes;
}
